import { Music, BookOpen, Palette, Activity, Feather, Heart, Sparkles } from "lucide-react";

const weekJourney = [
  { day: "Monday", theme: "Music Monday", icon: Music, focus: "Bhajans, rhymes & tabla claps", color: "from-orange-500 to-red-500", accent: "bg-orange-50" },
  { day: "Tuesday", theme: "Tale Tuesday", icon: BookOpen, focus: "Panchatantra + Ramayana stories", color: "from-amber-500 to-orange-600", accent: "bg-amber-50" },
  { day: "Wednesday", theme: "Wonder Wednesday", icon: Sparkles, focus: "Nature & science exploration", color: "from-emerald-500 to-teal-600", accent: "bg-emerald-50" },
  { day: "Thursday", theme: "Thought Thursday", icon: Feather, focus: "Sanskrit shloka & sanskaar", color: "from-fuchsia-500 to-purple-600", accent: "bg-fuchsia-50" },
  { day: "Friday", theme: "Fitness Friday", icon: Activity, focus: "Yoga, dance & outdoor games", color: "from-sky-500 to-blue-600", accent: "bg-sky-50" },
  { day: "Saturday", theme: "Sanskar Saturday", icon: Heart, focus: "Weekend Sanskar Kendra magic", color: "from-rose-500 to-pink-600", accent: "bg-rose-50" }
];

const WeeklyJourneyInfographic = () => (
  <section className="py-16 bg-gradient-to-b from-white via-amber-50/50 to-white" data-testid="weekly-journey-infographic">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">One Beautiful Week</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">A Week of Wonder at Aadi Gayanam</h2>
        <p className="text-stone-600 text-sm md:text-base">
          Every day has its own flavour — a theme that runs through morning circle, activities and story time. Six days, six adventures.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {weekJourney.map((d) => {
          const Icon = d.icon;
          return (
            <div
              key={d.day}
              className={`relative rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all hover:-translate-y-1 border border-orange-100 ${d.accent}`}
              data-testid={`week-day-${d.day.toLowerCase()}`}
            >
              <div className={`relative h-24 bg-gradient-to-br ${d.color} p-4 flex items-center gap-3 overflow-hidden`}>
                <div className="absolute inset-0 opacity-15 pointer-events-none">
                  <div className="absolute -top-4 -right-4 w-24 h-24 border-2 border-white rounded-full" />
                </div>
                <div className="relative z-10 w-12 h-12 rounded-2xl bg-white/95 flex items-center justify-center shadow">
                  <Icon className={`w-6 h-6 text-orange-800`} />
                </div>
                <div className="relative z-10 text-white">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-white/90">{d.day}</p>
                  <h3 className="font-display text-lg font-bold leading-tight">{d.theme}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-stone-700 leading-relaxed">{d.focus}</p>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-center text-xs text-stone-500 mt-8 max-w-2xl mx-auto italic">
        (Sundays are for hugs at home, family walks and helping mummy in the kitchen 💛)
      </p>
    </div>
  </section>
);

export default WeeklyJourneyInfographic;
